import $ from "jquery"

$ ->
  $('.exp-days-field > ').each (n, el) ->
    cb = $(el)
    rb = cb.find("input[type=\"radio\"")
    text = cb.find("input[type=\"text\"")
    rb.on "click", ->
      text.select()
      text.focus()
    text.on "focus", ->
      rb.prop("checked", true)
